const axios = require('axios');
import AuthStore from '../stores/AuthStore';

function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

class OdooClass{
    constructor() {
      const conf = window.ODOO
      this.url = conf.url + (conf.port?':'+conf.port:'')+'/transport/'
    }

    call(model, method, params, login, password) {
      let log = login || AuthStore.getUser().login
      let pwd = password || AuthStore.getUser().password
      let req = {
        'login': log,
        'password': pwd,
        'model': model,
        'method': method,
        'params': params
      }
      req = b64EncodeUnicode(JSON.stringify(req))

      let spinner = document.querySelector('.loaderWrap')
      let spinnerTimout = setTimeout(()=>{
        spinner.style.display = 'block'
      }, 1000)

      return new Promise((resolve, reject) => {
        axios.get(this.url+req/*, {withCredentials: true}*/)
          .then(function (response) {
            if(response.status == 200){
              if(response.data.error){
                reject(response.data.message)
              }
              resolve(response.data)
            } else {
              reject('Wystąpił nieznany błąd');
            }
          })
          .catch(function () {
            reject('Wystąpił nieznany błąd')
          }).then(() => {
            spinner.style.display = 'none'
            clearTimeout(spinnerTimout)
          })
      });
    }
}

const Odoo = new OdooClass();

export default Odoo;



// WEBPACK FOOTER //
// ./src/utils/Odoo.js